import ReactGA from 'react-ga4';

// Initialize Google Analytics
export const initGA = (measurementId) => {
  console.log(`Attempting to initialize GA with ID: ${measurementId}`);
  
  if (!measurementId) {
    console.warn('GA Measurement ID is not provided');
    return;
  }

  // For testing - enable in development too
  // if (process.env.NODE_ENV === 'development') {
  //   console.log('GA disabled in development mode');
  //   return;
  // }

  try {
    ReactGA.initialize(measurementId);
    console.log('GA initialized successfully with ID:', measurementId);
  } catch (error) {
    console.error('Failed to initialize Google Analytics:', error);
  }
};

// Track page views
export const trackPageView = (path) => {
  console.log(`Tracking page view: ${path}`);
  
  // For testing - still log in development
  if (process.env.NODE_ENV === 'development') {
    console.log(`[GA] Page view tracked: ${path}`);
    // Don't return early for testing
    // return;
  }
  
  try {
    ReactGA.send({ hitType: 'pageview', page: path });
    console.log(`Successfully sent pageview for: ${path}`);
  } catch (error) {
    console.error('Error tracking page view:', error);
  }
};

// Track custom events
export const trackEvent = (category, action, label, value) => {
  console.log(`Tracking event: ${category} / ${action} / ${label} / ${value}`);
  
  // For testing - still log in development
  if (process.env.NODE_ENV === 'development') {
    console.log(`[GA] Event tracked: ${category} / ${action} / ${label} / ${value}`);
    // Don't return early for testing
    // return;
  }
  
  try {
    ReactGA.event({
      category,
      action,
      label,
      value
    });
    console.log(`Successfully sent event: ${category} / ${action}`);
  } catch (error) {
    console.error('Error tracking event:', error);
  }
};
